
import React, { useState } from "react";
import axios from "axios";
import "./Login.css";
import imagenDerecha from "../assets/Login.jpg";
import logo from "../assets/Logo.png";
import logoG360 from "../assets/Logo_G360_Black.png";
import { toast } from "react-toastify";
import PageTitle from "../components/PageTitle";

function Login({ onLoginSuccess }) {
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_LOGIN;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_URL,
        { correo, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const token = res.data.token;
      const user = res.data.user;

      if (!token || !user) {
        toast.error("El servidor no devolvió una sesión válida");
        return;
      }

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      if (onLoginSuccess) {
        onLoginSuccess(
          {
            ...user,
            token,
          },
          rememberMe
        );
      }

      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 400);
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      toast.error(
        error.response?.data?.message || "Usuario o contraseña incorrectos"
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <>

      <PageTitle title="Login" />

      <div className="login-page">
        <div className="login-left">

          {/* Logo */}
          <div className="login-logo">
            <img
              src={logoG360}
              alt="Logo Gestión360"
              className="empresa-logo g360-logo"
            />

            <div className="logo-divider"></div>
 
            <img
              src={logo}
              alt="Logo Fondo Manpower"
              className="empresa-logo"
            />


          </div>

          <div className="login-content">
            <h1 className="welcome-text">
              ¡Bienvenido a G360!
            </h1>
            <p className="subtext">¡Tu lugar para organizar, gestionar y avanzar!</p>

            {/* Formulario */}
            <form className="login-form" onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Usuario"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                required
              />

              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <div className="options">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>Recordarme</span>
                </label>

                <a className="forgot-password">
                  ¿Olvidaste tu contraseña?
                </a>
              </div>

              <button type="submit" disabled={loading}>
                {loading ? "Ingresando..." : "Iniciar sesión"}
              </button>
            </form>
          </div>

          <div className="login-footer">
            <p>
              ¿Aún no tienes una cuenta? <a>Regístrate</a>
            </p>
          </div>
        </div>

        <div className="login-right">
          <img src={imagenDerecha} alt="Imagen empresarial" />
        </div>
      </div>

    </>

  );
}

export default Login;
